
import generalMixin from '~/mixins/generalMixin'

export default {
  mixins: [
    generalMixin
  ],

  props: {
    countriesOptions: {
      type: Array,
      default () {
        return []
      },
      required: true
    }
  },

  data () {
    return {
      form: {
        exp_level: [],
        role: null,
        pay_min: null,
        pay_max: null,
        availability: [],
        country: null
      },
      unlimitedBudget: true,

      exp_options: [
        { value: 'junior', text: this.$t('levels.junior.title') },
        { value: 'medior', text: this.$t('levels.medior.title') },
        { value: 'senior', text: this.$t('levels.senior.title') }
      ],
      role_options: [
        { value: null, text: this.$t('no_selection') },
        { value: 'admin', text: this.$t('roles.admin.title') },
        { value: 'developer', text: this.$t('roles.developer.title') },
        { value: 'devops', text: this.$t('roles.devops.title') },
        { value: 'consultant', text: this.$t('roles.consultant.title') },
        { value: 'analyst', text: this.$t('roles.analyst.title') },
        { value: 'owner', text: this.$t('roles.owner.title') },
        { value: 'pm', text: this.$t('roles.pm.title') },
        { value: 'sa', text: this.$t('roles.sa.title') },
        { value: 'ta', text: this.$t('roles.ta.title') },
        { value: 'marketer', text: this.$t('roles.marketer.title') }
      ],
      availability_options: [
        { value: 'asneeded', text: this.$t('availability.asneeded') },
        { value: 'fulltime', text: this.$t('availability.fulltime') },
        { value: 'upto30', text: this.$t('availability.upto30') },
        { value: 'upto20', text: this.$t('availability.upto20') }
      ]
    }
  },

  created () {
    this.populateQuery()
  },

  methods: {
    budgetClick () {
      this.unlimitedBudget = !this.unlimitedBudget
    },

    populateQuery () {
      const params = this.urlGetParams(!!this.$route.params && !!this.$route.params.filter ? this.$route.params.filter : {})

      this.form = {
        exp_level: Array.isArray(params.exp_level) ? params.exp_level : (!!params.exp_level ? [params.exp_level] : []),
        role: params.role ?? null,
        pay_min: params.pay_min ?? null,
        pay_max: params.pay_max ?? null,
        availability: Array.isArray(params.availability) ? params.availability : (!!params.availability ? [params.availability] : []),
        country: params.country ?? null
      }

      if (!!this.form.pay_min || !!this.form.pay_max) {
        this.unlimitedBudget = false
      }
    },

    applyFilter () {
      if (!!this.form.pay_max && this.form.pay_max < this.form.pay_min) {
        const max = this.form.pay_max
        this.form.pay_max = this.form.pay_min
        this.form.pay_min = max
      }
      const filter = this.urlBuildParams(this.form)

      if (!!filter) {
        this.$router.push(this.localePath({ name: 'contractors-filter', params: { filter } }))
      } else {
        this.$router.push(this.localePath({ name: 'contractors' }))
      }
    }
  }
}
